import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const historyRoute: RouteConfig<'with-page'> = {
    name: 'View Send History',
    path: '/send-documents/history',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['companyDocuments', 'sendCompanyDocuments'],
}
